import {ActivatedRoute, CanActivateFn, Router} from '@angular/router';
import {dinamicQuestionModules} from '../../data/questionData';
import {inject} from '@angular/core';
import {NotificationService} from '../../../assets/shared/notification/notification.service';


export const TestGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const notification = inject(NotificationService);

  const coursesId = route.parent?.paramMap.get('coursesId');
  const type = route.paramMap.get('type');
  const moduleNumber = route.paramMap.get('module');

  if (!coursesId || !type || !moduleNumber) {notification.show("error", 'Некорректный путь', '');return router.createUrlTree(['/home']);
  }

  const course = dinamicQuestionModules.find(item => Number(item.courseId) === Number(coursesId));

  const moduleExists = course?.modules.some(item =>
   String(item.moduleType) == String(type) &&
    Number(item.moduleNumber) == Number(moduleNumber)
  );

  if (moduleExists) {
    return true;
  }

  notification.show("error", 'Такого теста или модуля не существует', '');
  return router.createUrlTree(['**']);
};
